import { LEADS_ROUTES } from '../constants/routes';
import { LEAD_DEPARTMENT as DEPARTMENT } from '../constants/enums';

/**
 * Leads is for Sales, Marketing and Executive (A9, FL11). Sales gets Leads
 * without QR & Links. The server's per-op `can()` is the real gate; these
 * rules decide navigation and which controls are drawn.
 */
const LEADS_RULE = Object.freeze({
  departments: [DEPARTMENT.SALES, DEPARTMENT.MARKETING, DEPARTMENT.EXECUTIVE],
  roles: [],
});

/** Lead assignment settings: Sales and Executive (Executive passes every route rule). */
const ASSIGNMENT_RULE = Object.freeze({
  departments: [DEPARTMENT.SALES, DEPARTMENT.EXECUTIVE],
  roles: [],
});

const RULE_BY_PATH = Object.freeze({ [LEADS_ROUTES.ASSIGNMENT]: ASSIGNMENT_RULE });

export const LEADS_ROUTE_ACCESS = Object.freeze(
  Object.fromEntries(Object.values(LEADS_ROUTES).map((path) => [path, RULE_BY_PATH[path] || LEADS_RULE]))
);

/** Leads feature access — registered in configs/featureAccess. */
export const leadsAccess = {
  id: 'leads',
  routes: LEADS_ROUTE_ACCESS,
  buttons: Object.freeze({}),
};
